import Typography from '@mui/material/Typography';

interface Props {
  readonly children: string;
}

export const PrimaryWrapper = ({ children }: Readonly<Props>) => (
  <Typography component="span" gutterBottom variant="body1">
    {children}
  </Typography>
);
